import React from 'react'
import "../Styles/Past_tour.css"
import { useEffect, useState } from 'react'
import "../Styles/Upcoming_tour_content.css"
import Rajasthan from "../Images/rajasthan_pic.png"
import api from '../Api.js'
import dayjs from 'dayjs'

function Past_tour() {
const [openPopupUnique, setOpenPopupUnique] = React.useState(false);
const openPopupUniqueBotton = () => {
  setOpenPopupUnique(true);
}
const closePopupUniquebotton = ()=>{
  setOpenPopupUnique(false);
  document.getElementById("popupUnique").style.display="none";
}
    const [upcomingTours, setUpcomingTours] = useState([]);
    const accessToken = localStorage.getItem('accessToken');

    useEffect(() => {
        const fetchUpcomingTours = async () => {
            try {
                const response = await api.get('/user/bookings/paid', {

                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${accessToken}`,
                    },
                });
                console.log('Upcoming Tours:', response.data);
                if(response.data.success === true){
                      setUpcomingTours(response.data.data);
                }
              
            } catch (error) {
                console.error('Error fetching upcoming tours:', error);
            }
        };
        fetchUpcomingTours();

    }, []);
    const Past_tours = upcomingTours.filter((tour) => dayjs(tour?.tour_end_date).isBefore(dayjs()));
    console.log("Past Tours:", Past_tours);
    const formatDate = (date) => dayjs(date).format("D MMM h:mm a");
  return (
    <div>

{openPopupUnique && <div class="popup-overlay-unique" id="popupUnique">
  <div class="popup-box-unique">
    <form class="popup-form-unique">
      <h2 class="popup-title-unique">⭐ Review Your Tour</h2>

      
      <div class="rating-unique">
        <input type="radio" id="star5" name="rating" value="5" />
        <label for="star5" title="5 stars">★</label>

        <input type="radio" id="star4" name="rating" value="4" />
        <label for="star4" title="4 stars">★</label>

        <input type="radio" id="star3" name="rating" value="3" />
        <label for="star3" title="3 stars">★</label>

        <input type="radio" id="star2" name="rating" value="2" />
        <label for="star2" title="2 stars">★</label>

        <input type="radio" id="star1" name="rating" value="1" />
        <label for="star1" title="1 star">★</label>
      </div>

      
      <textarea class="review-text-unique" placeholder="Write your review here..."></textarea>

    
      <button type="submit" class="popup-submit-btn-unique">Submit Review</button>
      <button type="button" class="popup-close-btn-unique" onClick={closePopupUniquebotton}>Close</button>
    </form>
  </div>
</div> }



{Past_tours.map((tour) => (
      <div class="tripCard_wrapper">
        <div class="tripCard_image">
          <img src={tour?.tour?.destination?.image} alt="Rajasthan Tour" />
        </div>
        <div class="tripCard_content">
          <h2 class="tripCard_title">{tour?.tour?.title}</h2>
          <p class="tripCard_date">{`${formatDate(tour?.tour_start_date)} - ${formatDate(tour?.tour_end_date)}`}</p>
          <div class="tripCard_buttons">
            <button class="tripCard_btnDetails" onClick={openPopupUniqueBotton}>Review</button>
             {/* <button className="tripCard_btnCancel">Remove</button> */}
            {/* <button class="tripCard_btnCancel">Cancel</button> */}
          </div>
        </div>
      </div>
))}


    </div>
  )
}

export default Past_tour